import React from "react"
import Select, { components } from "react-select"
import "./SelectField.css"
import { ArrowDownIcon, CloseIcon } from "../../Icons"

const selectStyle = {
  clearIndicator: () => ({}),
  container: () => ({}),
  control: () => ({}),
  dropdownIndicator: () => ({}),
  group: () => ({}),
  groupHeading: () => ({}),
  indicatorsContainer: () => ({}),
  indicatorSeparator: () => ({}),
  input: () => ({}),
  loadingIndicator: () => ({}),
  loadingMessage: () => ({}),
  menu: () => ({}),
  menuList: () => ({}),
  menuPortal: () => ({}),
  multiValue: () => ({}),
  multiValueLabel: () => ({}),
  multiValueRemove: () => ({}),
  noOptionsMessage: () => ({}),
  option: () => ({}),
  placeholder: () => ({}),
  singleValue: () => ({}),
  valueContainer: () => ({})
}

function Menu(props) {
  const { children, innerRef, innerProps } = props
  return (
    <div className={`Menu ${props.placement}`} {...innerProps} ref={innerRef}>
      <div className="menu-content">{children}</div>
    </div>
  )
}

function RemoveValue(props) {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon />
    </components.MultiValueRemove>
  )
}

function MenuList(props) {
  const children = props.children

  if (!children.length) {
    return <div className="myClassListName">{children}</div>
  }

  return (
    <div className="myClassListName">
      {children.length &&
        children.map((key, i) => {
          delete key.props.innerProps.onMouseMove //FIX LAG!!
          delete key.props.innerProps.onMouseOver //FIX LAG!!

          return (
            <div className="myClassItemName" key={i}>
              {key}
            </div>
          )
        })}
    </div>
  )
}

class SelectField extends React.Component {
  handleChange(data, { action }) {
    const { form, field } = this.props
    form.setFieldTouched(field.name)
    switch (action) {
      case "select-option":
      case "remove-value":
        form.setFieldValue(field.name, data)
        break
      default:
        break
    }
  }
  render() {
    const props = this.props
    const {
      field,
      form: { touched, errors },
      disabled
    } = this.props

    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (touched[field.name] && field.value && !errors[field.name]) {
      status = "is-fixed"
    }

    return (
      <>
        <Select
          className={`SelectField ${status}`}
          classNamePrefix="SelectField"
          styles={selectStyle}
          isClearable={false}
          menuPlacement="auto"
          onChange={this.handleChange.bind(this)}
          isDisabled={disabled}
          {...props}
          components={{
            ...props.components,
            Menu: { ...props.components }.hasOwnProperty("Menu")
              ? { ...props.components }.Menu
              : Menu,
            DropdownIndicator: () => <ArrowDownIcon />,
            MultiValueRemove: RemoveValue,
            MenuList: MenuList
          }}
        />
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
      </>
    )
  }
}
export default SelectField
